import React, { useEffect, useState } from 'react'
import { crearDatos, getDataList } from '../api/common'
import { Modales } from '../components/Modales'
import { EditarRoles } from '../components/Roles/EditaRoles'
import Spinner from '../components/commons/Spinner'
import { Modalcarga } from '../components/Modales/Modalcarga'
import { Alertassw } from '../components/Alertas/Alertassw'
import { InactivarRol } from '../components/Roles/InactivarRol'
import { ModalPermisos } from '../components/Roles/ModalPermisos'
import { Permisos } from '../components/Roles/Permisos'

export const Rolescreate = () => {
    const [getroles, setGetroles] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [spinnerMod, setSpinnerMod] = useState(false)

    // Modal: descripción
    const [modalDesc, setModalDesc] = useState(false)
    const [descInfo, setDescInfo] = useState({})

    // Modal: editar rol
    const [modalEdit, setModalEdit] = useState(false)
    const [rolData, setRolData] = useState()

    // Modal: inactivar/activar
    const [modalDel, setModalDel] = useState(false)

    // Modal: permisos
    const [modalPermisos, setModalPermisos] = useState(false)

    // Modal: crear nuevo rol
    const [modalCrear, setModalCrear] = useState(false)
    const [nuevoRol, setNuevoRol] = useState({ nombre: '', area: '', descripcion: '' })
    const [permisosNuevo, setPermisosNuevo] = useState(new Set())

    const todoPermisos = Permisos().filter(p => p !== '')

    // ── Handlers ───────────────────────────────────────────────────
    const viewDescripcion = (rol) => { setDescInfo(rol); setModalDesc(true) }
    const viewPermisos = (rol) => { setRolData(rol); setModalPermisos(true) }
    const editRol = (rol) => { setRolData(rol); setModalEdit(true) }
    const inactivar = (rol) => { setRolData(rol); setModalDel(true) }

    const handleNuevoRol = (e) => {
        setNuevoRol(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const togglePermisosNuevo = (permiso) => {
        setPermisosNuevo(prev => {
            const next = new Set(prev)
            next.has(permiso) ? next.delete(permiso) : next.add(permiso)
            return next
        })
    }

    const abrirCrear = () => {
        setNuevoRol({ nombre: '', area: '', descripcion: '' })
        setPermisosNuevo(new Set())
        setModalCrear(true)
    }

    const saveRol = async (e) => {
        e.preventDefault()
        setSpinnerMod(true)
        try {
            const payload = { ...nuevoRol, permisos: [...permisosNuevo] }
            const result = await crearDatos('roles', payload)
            if (result.status === 200) {
                Alertassw('success', 'Rol creado correctamente')
                setRefresh(r => !r)
                setModalCrear(false)
            }
        } catch (error) {
            Alertassw('error', 'Error en la creación', 'Verifica los campos e ingresa los valores correctos')
        }
        setSpinnerMod(false)
    }

    useEffect(() => {
        async function getRoles() {
            const result = await getDataList('roles')
            setGetroles(result.data.data)
        }
        getRoles()
    }, [refresh])

    return (
        <div>
            <Modalcarga estadoIn={spinnerMod} cambiarestadoIn={setSpinnerMod}>
                <Spinner />
            </Modalcarga>

            {/* Modal: descripción */}
            <Modales
                estado={modalDesc}
                cambiarestado={setModalDesc}
                titulo={`Descripción: ${descInfo.nombre}`}
            >
                <p className='descripcionmodal'>{descInfo.descripcion}</p>
            </Modales>

            {/* Modal: editar rol */}
            <Modales estado={modalEdit} cambiarestado={setModalEdit} titulo='Editar rol'>
                {rolData && (
                    <EditarRoles
                        rolData={rolData}
                        cambiarestado={setModalEdit}
                        setRefresh={setRefresh}
                        refresh={refresh}
                        setSpinnerMod={setSpinnerMod}
                    />
                )}
            </Modales>

            {/* Modal: inactivar/activar */}
            <Modales estado={modalDel} cambiarestado={setModalDel} titulo={rolData?.status === 'activo' ? 'Inactivar Rol' : 'Activar Rol'}>
                {rolData && (
                    <InactivarRol
                        dataRol={rolData}
                        cambiarestado={setModalDel}
                        setRefresh={setRefresh}
                        refresh={refresh}
                        setSpinnerMod={setSpinnerMod}
                    />
                )}
            </Modales>

            {/* Modal: gestionar permisos */}
            <Modales
                estado={modalPermisos}
                cambiarestado={setModalPermisos}
                titulo={`Permisos — ${rolData?.nombre}`}
            >
                {rolData && (
                    <ModalPermisos
                        rol={rolData}
                        cambiarestado={setModalPermisos}
                        setRefresh={setRefresh}
                        refresh={refresh}
                        setSpinnerMod={setSpinnerMod}
                    />
                )}
            </Modales>

            {/* Modal: crear nuevo rol */}
            <Modales estado={modalCrear} cambiarestado={setModalCrear} titulo='Nuevo Rol'>
                <form className='crear-rol-modal' onSubmit={saveRol}>
                    <div className='crear-rol-grid'>
                        <div className='form-field'>
                            <label htmlFor='nombre'>Nombre del Rol</label>
                            <input
                                id='nombre'
                                type='text'
                                name='nombre'
                                placeholder='Ej: Técnico calibrador'
                                value={nuevoRol.nombre}
                                onChange={handleNuevoRol}
                                required
                            />
                        </div>
                        <div className='form-field'>
                            <label htmlFor='area'>Área</label>
                            <input
                                id='area'
                                type='text'
                                name='area'
                                placeholder='Ej: Laboratorio'
                                value={nuevoRol.area}
                                onChange={handleNuevoRol}
                                required
                            />
                        </div>
                        <div className='form-field span-2'>
                            <label htmlFor='descripcion'>Descripción</label>
                            <textarea
                                id='descripcion'
                                name='descripcion'
                                placeholder='Breve descripción de las responsabilidades de este rol'
                                value={nuevoRol.descripcion}
                                onChange={handleNuevoRol}
                                required
                            />
                        </div>
                    </div>

                    <p className='permisos-section-title'>
                        <i className='bi bi-shield-check'></i>
                        Permisos ({permisosNuevo.size} seleccionados)
                    </p>
                    <div className='permisos-grid' style={{ maxHeight: '38vh', marginBottom: '14px' }}>
                        {todoPermisos.map((permiso, i) => (
                            <label
                                key={i}
                                className={`permiso-item ${permisosNuevo.has(permiso) ? 'permiso-activo' : ''}`}
                                onClick={() => togglePermisosNuevo(permiso)}
                            >
                                <input
                                    type='checkbox'
                                    checked={permisosNuevo.has(permiso)}
                                    onChange={() => togglePermisosNuevo(permiso)}
                                    onClick={e => e.stopPropagation()}
                                />
                                <span>{permiso}</span>
                            </label>
                        ))}
                    </div>

                    <button className='btn-btn-primary w-100' type='submit'>
                        <i className='bi bi-plus-circle'></i> Crear Rol
                    </button>
                </form>
            </Modales>

            {/* ── Encabezado ── */}
            <div className='roles-page-header'>
                <h5 className='roles-page-title'>
                    <i className='bi bi-shield-lock'></i> Roles
                </h5>
                <button className='btn-btn-primary' onClick={abrirCrear}>
                    <i className='bi bi-plus-circle'></i> Nuevo Rol
                </button>
            </div>

            {/* ── Grid de roles ── */}
            <div className='roles-grid'>
                {getroles && getroles.map(rol => (
                    <div className={`rol-card ${rol.status === 'inactivo' ? 'inactivo' : ''}`} key={rol._id}>
                        <div className='rol-card-header'>
                            <p className='rol-card-nombre' title={rol.nombre}>{rol.nombre}</p>
                            <span className={`rol-status-badge ${rol.status === 'activo' ? 'activo' : 'inactivo'}`}>
                                {rol.status}
                            </span>
                        </div>
                        <div className='rol-card-body'>
                            <p className='rol-card-area'>
                                <i className='bi bi-building'></i> {rol.area || '—'}
                            </p>
                            <div className='rol-card-actions'>
                                <span
                                    className='permisos-count'
                                    onClick={() => viewPermisos(rol)}
                                    title='Ver / editar permisos'
                                >
                                    <i className='bi bi-shield-check'></i>
                                    {rol.permisos?.length || 0} permisos
                                </span>
                                <div className='rol-card-icons'>
                                    <i
                                        className='bi bi-file-text icon-desc'
                                        title='Ver descripción'
                                        onClick={() => viewDescripcion(rol)}
                                    ></i>
                                    {rol.status !== 'inactivo' && (
                                        <i
                                            className='bi bi-pencil-square icon-edit'
                                            title='Editar'
                                            onClick={() => editRol(rol)}
                                        ></i>
                                    )}
                                    <i
                                        className={`bi ${rol.status === 'activo' ? 'bi-archive-fill icon-del' : 'bi-arrow-counterclockwise icon-edit'}`}
                                        title={rol.status === 'activo' ? 'Inactivar' : 'Activar'}
                                        onClick={() => inactivar(rol)}
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
